// extracted by mini-css-extract-plugin
module.exports = {"grid":"EmployeePositionsList_grid__tT83L","cellDetails":"EmployeePositionsList_cellDetails__uPykE"};